/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */

/**
 * Constants and helpers for the FSE prescription creator.
 * Extracted from PrescriptionCreator.jsx (Code Quality refactor).
 */

// Reference list of common Italian SSN exemption codes (subset). Purely a
// UX helper — the code is stored as a free string on the document.
export const EXEMPTIONS = [
  { code: '', label: 'Nessuna esenzione' },
  { code: '031', label: 'Ipertensione arteriosa' },
  { code: '013', label: 'Diabete mellito' },
  { code: '021', label: 'Cardiopatia ischemica' },
  { code: '027', label: 'Neoplasie maligne' },
  { code: '040', label: 'Insufficienza renale cronica' },
  { code: '048', label: 'Neoplasie a rischio' },
  { code: 'C01', label: 'Reddito familiare' },
  { code: 'E01', label: 'Invalidità civile' },
];

export const MAX_RX_ITEMS = 6;

export const newItemKey = () => `rx-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

export const emptyItem = () => ({
  _key: newItemKey(),
  name: '', aic: '', quantity: '1', posology: '', notes: '', active: '',
});

/** Build an item from a parsed dictation result. */
export const itemFromDictation = (parsed) => ({
  _key: newItemKey(),
  name: parsed.name || parsed.raw || '',
  aic: '',
  quantity: String(parsed.quantity || 1),
  posology: [parsed.dosage, parsed.posology, parsed.duration].filter(Boolean).join(' • '),
  notes: '',
  active: parsed.name || '',
});

/** Build an item from a saved template drug. */
export const itemFromTemplate = (d) => ({
  _key: newItemKey(),
  name: d.name || '',
  aic: d.aic || '',
  quantity: d.quantity || '1',
  posology: d.posology || '',
  notes: d.notes || '',
  active: d.active || '',
});
